export default function () {
  const widgetName = 'infographics';
  const widgetOpts = infographicsOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: [''],
    itemsPerPanel: 4,
    maxItemsVisible: 4,
    showDescription: true,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    textOverImage: false,
    buyNowButton: false,
    moreButton: false,

    cardWidgetLoaded: function (data) {
      const widgetData = data.items;

      if (widgetData.length < 1) {
        $(`.tier-4-container`).remove();
      }
    },
  });
}
